import { render, staticRenderFns } from "./FrontProductPage.vue?vue&type=template&id=0842c454"
import script from "./FrontProductPage.vue?vue&type=script&lang=js"
export * from "./FrontProductPage.vue?vue&type=script&lang=js"
import style0 from "./FrontProductPage.vue?vue&type=style&index=0&id=0842c454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports